
import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router, ActivatedRoute } from "@angular/router";
import { ApprovalDialogComponent } from "app/approval/approval-dialog/approval-dialog.component";
import { ReceiptDialogComponent } from "app/shared/receipt-dialog/receipt-dialog.component";
@Injectable({
  providedIn: 'root'
})
export class DialogHelper {

    showDialog(data: any,matDialog: MatDialog,router: Router,route: ActivatedRoute){
        let dialogOpened = matDialog.open(ReceiptDialogComponent,{
          data: data,
          disableClose: true,
          autoFocus: true,
          minWidth: '50%',
    
      
        });
        
        dialogOpened.afterClosed().subscribe(result => router.navigate(['../../'], { relativeTo: route }));
    }

    showDialogNoCloseAction(data: any,matDialog: MatDialog){
      let dialogOpened = matDialog.open(ReceiptDialogComponent,{
        data: data,
        disableClose: true,
        autoFocus: true,
        minWidth: '50%',
  
    
      });
    
  }

    showApprovalDialog(data: any,matDialog: MatDialog): MatDialogRef<ApprovalDialogComponent,any>{
      return matDialog.open(ApprovalDialogComponent,{
        data: data,
        disableClose: true,
        autoFocus: true,
        minWidth: '30%',
      });
    }
}